import PropTypes from 'prop-types';

export const documentDiscriminatorPropType = PropTypes.shape({
  extractionFieldId: PropTypes.string,
  fieldName: PropTypes.string,
  aiExtractionFieldName: PropTypes.string,
  value: PropTypes.string,
  belowThreshold: PropTypes.bool,
});
